import type { Config } from '@ms/yammer-libs-static-config';

type GetConfig = () => Config;
export const getConfig: GetConfig = () => window.__yammerconfig__ as Config;
